import { classnames } from '@tailwindcss-classnames';

// outer containers
export const detailsGrid = classnames(
  'grid',
  'grid-cols-1',
  'lg:grid-cols-12',
  'lg:gap-10',
  'gap-0',
  'pt-3',
  'md:pt-3',
  'lg:pt-20'
);

export const column = classnames(
  'col-span-1',
  'lg:col-span-5',
  'xl:col-span-5',
  'md:flex-shrink-0',
  'mt-3',
  'md:mt-0',
  'order-2'
);

export const reviewsContainer = classnames('mt-3', 'min-h-[17.5px]');
export const fullSpanWrapper = classnames('col-span-full');
export const regularMargin = classnames('mb-6');

// product information (name, description, price, affirm)
export const mainDetail = classnames(
  'grid',
  'gap-x-4',
  'gap-y-1',
  'md:gap-y-2',
  'grid-cols-6',
  'mt-3',
  'mb-3',
  'md:mb-4'
);

export const titleBase = classnames('h4');
export const greyText = classnames(
  'text-nzxt-light-grey-800',
  'dark:text-nzxt-dark-grey-200'
);
export const titlePrice = classnames(
  'font-semibold',
  'text-nzxt-light-grey-800',
  'dark:text-white',
  'space-x-2',
  'text-right',
  'my-auto',
  'flex',
  'col-span-full',
  'text-2xl'
);

const priceDiscounted = classnames(
  'line-through',
  'text-nzxt-light-grey-600',
  'dark:text-nzxt-dark-grey-200'
);
export const discountedPricedText = classnames(
  'text-nzxt-light-grey-800',
  'dark:text-white'
);
export const isOnSale = (salePrice: boolean): string =>
  classnames({ [priceDiscounted]: salePrice });

// services and policies
export const servicesWrapper = classnames(
  'col-span-6',
  'flex',
  'flex-wrap',
  'mb-2'
);
export const policiesWrapper = classnames(
  'space-y-2',
  'mb-3',
  'mt-3',
  'pt-6',
  'border-t',
  'dark:border-t-nzxt-dark-grey-100'
);

export const smallSpaceDivider = classnames('pt-3');
